import $ from 'jquery'
import React from 'react'
import { Component } from 'react';

import Chart from "react-apexcharts";


//import Measure from 'react-measure'


const MIN_YEAR = 1000;
const MAX_YEAR = 2030;

class ApexTimeline extends Component {

    state = {
        options: null,
        series: null,
    };

    createApexData = (timeline) => {
        if (!timeline || !timeline.items) return {
            options: null,
            series: null,
        };
        return {
            options: {
                chart: {
                    id: "citation-timeline",
                    zoom: {
                        enabled: true,
                        type: 'x'
                    },
                    animations: {
                        enabled: false,
                    },
                    events: {
                        dataPointSelection: this.handleDataPointClick
                    }
                },
                xaxis: {
                    type: 'numeric',
                    min: timeline && timeline.items[0] ? timeline.items[0].x -5: MIN_YEAR ,
                    max: timeline && timeline.items.length>0 && timeline.items[timeline.items.length-1].x ? timeline.items[timeline.items.length-1].x +5 : MAX_YEAR,
                    tickAmount: 20,
                    labels: {
                        formatter: function(val) {
                            return parseFloat(val).toFixed()
                        }
                    }
                },
                yaxis: {
                    show: false,
                },
                markers: {
                    strokeColors: "#00000030",
                },
                fill: {
                    colors: ["#008bc1"],
                    opacity: 0.3,
                },
                tooltip: {
                    y: {
                        formatter: this.tooltipFormatter,
                        title: {
                            formatter: (seriesName) => ("Metapher")
                        }
                    }
                },
            },
            series: [
                {
                    name: "Zitate",
                    data: timeline.items.map((item, i) => (
                        [item.x, item.y]
                    ))
                }
            ]
        };
    };

    tooltipFormatter = (value, { series, seriesIndex, dataPointIndex, w }) => {
        try {
            return this.props.timeline.items[dataPointIndex].title;
        } catch (e) {
            return "-";
        }
        // return `${value} ${seriesIndex} ${dataPointIndex} ${w}`
    };

    handleDataPointClick = (event, chartContext, config) => {
        const
            dataPointIndex = config.dataPointIndex,
            zitatPk = this.props.timeline.items[dataPointIndex].pk;

        if (this.props.onZitatClick)
            this.props.onZitatClick(zitatPk);
    };

    componentDidMount() {
        this.setState(this.createApexData(this.props.timeline));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.timeline !== this.props.timeline) {
            this.setState(this.createApexData(this.props.timeline));
        }
    };

    render() {
        const { timeline, onZitatClick } = this.props;

        if (!this.state.series)
            return null;

        return (
            <Chart
                options={this.state.options}
                series={this.state.series}
                type={"scatter"}
                height={"300px"}
                //width={"500"}
            />
        );
    }
}

export default ApexTimeline


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/ApexTimeline.js